/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"],
  _excluded2 = ["isSelected", "frameStyle", "minWidth", "maxWidth", "isInteractive", "inheritDimensions"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["isSelected", "frameStyle", "minWidth", "maxWidth", "isInteractive", "inheritDimensions"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["frameStyle"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["isPlaceholder"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["isPlaceholder"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"],
  _excluded13 = ["removeOverflow", "allowScrollBar", "frameStyle"],
  _excluded14 = ["as", "style"],
  _excluded15 = ["as", "style"];
import "./styled.compiled.css";
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */

import { B100, B50, N30, N300, N40 } from '@atlaskit/theme/colors';
export var className = 'media-card-frame';
export var embedHeaderHeight = 32;
// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
export var LinkWrapperOldVisualRefresh = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "div" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  var isSelected = __cmplp.isSelected,
    frameStyle = __cmplp.frameStyle,
    minWidth = __cmplp.minWidth,
    maxWidth = __cmplp.maxWidth,
    isInteractive = __cmplp.isInteractive,
    inheritDimensions = __cmplp.inheritDimensions,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_10q0298": ix(__cmplp.minWidth, "px"),
      "--_1et2rhb": ix(__cmplp.maxWidth, "px")
    }),
    ref: __cmplr,
    className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy _9oik1r31 _1bnxglyw _jf4cnqa1", __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34", __cmplp.minWidth && "_1ul91pd6", __cmplp.maxWidth && "_p12f1ayu", __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr", __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a", __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf", __cmplp.isInteractive && "_1di629zg", __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf", __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz", __cmplp.frameStyle === 'show' && "_631ousvi", __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw", __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7", __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7", __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1hfkhp5a" : "_1hfk1kw7", __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7", __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7", __cmplp.className])
  }));
});

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  LinkWrapperOldVisualRefresh.displayName = 'LinkWrapperOldVisualRefresh';
}
export var WrapperOldVisualRefresh = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? "div" : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  var isSelected = __cmplp.isSelected,
    frameStyle = __cmplp.frameStyle,
    minWidth = __cmplp.minWidth,
    maxWidth = __cmplp.maxWidth,
    isInteractive = __cmplp.isInteractive,
    inheritDimensions = __cmplp.inheritDimensions,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded4);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_10q0298": ix(__cmplp.minWidth, "px"),
      "--_1et2rhb": ix(__cmplp.maxWidth, "px")
    }),
    ref: __cmplr,
    className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _19pk19bv _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy", __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34", __cmplp.minWidth && "_1ul91pd6", __cmplp.maxWidth && "_p12f1ayu", __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rh6cr", __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a", __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf", __cmplp.isInteractive && "_1di629zg", __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf", __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz", __cmplp.frameStyle === 'show' && "_631ousvi", __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw", __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7", __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43h6cr" : "_eq431kw7", __cmplp.frameStyle === 'show' ? "_1hfkhp5a" : "_1hfk1kw7", __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7", __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3umqxb" : "_8x3u1kw7", __cmplp.className])
  }));
});

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  WrapperOldVisualRefresh.displayName = 'WrapperOldVisualRefresh';
}
export var HeaderOldVisualRefresh = forwardRef(function (_ref3, __cmplr) {
  var _ref3$as = _ref3.as,
    C = _ref3$as === void 0 ? "div" : _ref3$as,
    __cmpls = _ref3.style,
    __cmplp = _objectWithoutProperties(_ref3, _excluded5);
  var frameStyle = __cmplp.frameStyle,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_v564ojwh _4t3izwfg _kqswstnw _1pbykb7n _1bsb1osq _1e0c1txw _4cvr1h6o _syazqjbk _tzy4idpf", __cmplp.frameStyle === 'show' && "_vchhusvi", __cmplp.frameStyle === 'show' && "_1yt4h8dc", __cmplp.className])
  }));
});

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  HeaderOldVisualRefresh.displayName = 'HeaderOldVisualRefresh';
}
export var IconWrapperOldVisualRefresh = forwardRef(function (_ref4, __cmplr) {
  var _ref4$as = _ref4.as,
    C = _ref4$as === void 0 ? "div" : _ref4$as,
    __cmpls = _ref4.style,
    __cmplp = _objectWithoutProperties(_ref4, _excluded7);
  var isPlaceholder = __cmplp.isPlaceholder,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded8);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko1sit _1bsb7vkz _4t3i7vkz _2hwx1b66", __cmplp.isPlaceholder && "_bfhkqrzy", __cmplp.className])
  }));
});

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  IconWrapperOldVisualRefresh.displayName = 'IconWrapperOldVisualRefresh';
}
export var TextWrapperOldVisualRefresh = forwardRef(function (_ref5, __cmplr) {
  var _ref5$as = _ref5.as,
    C = _ref5$as === void 0 ? "div" : _ref5$as,
    __cmpls = _ref5.style,
    __cmplp = _objectWithoutProperties(_ref5, _excluded9);
  var isPlaceholder = __cmplp.isPlaceholder,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded10);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_11c8dcr7 _1reo15vq _18m915vq _syaz1rc1 _1bto1l2s _o5721q9c", __cmplp.isPlaceholder && "_2rko1sit", __cmplp.isPlaceholder && "_1bsb176v", __cmplp.isPlaceholder && "_4t3i1crf", __cmplp.isPlaceholder && "_bfhkqrzy", __cmplp.className])
  }));
});

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  TextWrapperOldVisualRefresh.displayName = 'TextWrapperOldVisualRefresh';
}
export var TooltipWrapperOldVisualRefresh = forwardRef(function (_ref6, __cmplr) {
  var _ref6$as = _ref6.as,
    C = _ref6$as === void 0 ? "div" : _ref6$as,
    __cmpls = _ref6.style,
    __cmplp = _objectWithoutProperties(_ref6, _excluded11);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1reo15vq _18m915vq", __cmplp.className])
  }));
});

// TODO Delete when cleaning platform-linking-visual-refresh-v1
// NB: `overflow` is kept as `hidden` since
// the internal contents of the `iframe` should
// manage scrolling behaviour.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  TooltipWrapperOldVisualRefresh.displayName = 'TooltipWrapperOldVisualRefresh';
}
export var ContentOldVisualRefresh = forwardRef(function (_ref7, __cmplr) {
  var _ref7$as = _ref7.as,
    C = _ref7$as === void 0 ? "div" : _ref7$as,
    __cmpls = _ref7.style,
    __cmplp = _objectWithoutProperties(_ref7, _excluded12);
  var removeOverflow = __cmplp.removeOverflow,
    allowScrollBar = __cmplp.allowScrollBar,
    frameStyle = __cmplp.frameStyle,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded13);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rkoiti9 _19ith6cr _v56414ba _bfhkhp5a _kqswstnw _1pbykb7n _hlq8idpf _rd9b1wug _1g4jidpf _jk3p1wug", !__cmplp.removeOverflow && (__cmplp.allowScrollBar ? "_1reo1wug _18m91wug" : "_1reo15vq _18m915vq"), __cmplp.frameStyle === 'show' ? "_1bsbwgg2" : "_1bsb1osq", __cmplp.frameStyle === 'show' && "_18s81xf9", __cmplp.frameStyle === 'hide' ? "_4t3i1osq" : "_4t3i1j2a", __cmplp.frameStyle !== 'hide' && "_154ixy5q", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  ContentOldVisualRefresh.displayName = 'ContentOldVisualRefresh';
}
var getSizeWithUnit = function getSizeWithUnit() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  var unit = typeof value === 'number' ? 'px' : '';
  return "".concat(value).concat(unit);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
export var Image = forwardRef(function (_ref8, __cmplr) {
  var _ref8$as = _ref8.as,
    C = _ref8$as === void 0 ? "img" : _ref8$as,
    __cmpls = _ref8.style,
    __cmplp = _objectWithoutProperties(_ref8, _excluded14);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_rcxkve": ix(getSizeWithUnit(__cmplp.size))
    }),
    ref: __cmplr,
    className: ax(["_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
if (process.env.NODE_ENV !== 'production') {
  Image.displayName = 'Image';
}
export var Thumbnail = forwardRef(function (_ref9, __cmplr) {
  var _ref9$as = _ref9.as,
    C = _ref9$as === void 0 ? "div" : _ref9$as,
    __cmpls = _ref9.style,
    __cmplp = _objectWithoutProperties(_ref9, _excluded15);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_13orr8u": ix("url(".concat(__cmplp.src, ")"))
    }),
    ref: __cmplr,
    className: ax(["_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  Thumbnail.displayName = 'Thumbnail';
}